import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from '~/eds/src/components/Button/Button';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Section } from '~/eds/src/components/Section/Section';
import { Text } from '~/eds/src/components/Text/Text';
import { SharepointStatusType } from '~/enums/SharepointType';

function MicrosoftWordIntegrationInfo({
  sharePointSiteUrl,
  tenantId,
  status,
  onManageConfiguration,
}: {
  sharePointSiteUrl: string;
  tenantId: string;
  status?: SharepointStatusType;
  onManageConfiguration: () => void;
}) {
  const intl = useIntl();
  return (
    <Layout direction="column" spacing={4}>
      <Section
        heading="h4"
        title={intl.formatMessage({
          id: 'MicrosoftWordIntegrationInfo.TitleSuccess',
          defaultMessage:
            'Your organization is fully integrated with Microsoft Word.',
          description:
            'Title for success message of Microsoft Word integration',
        })}
      >
        <Layout direction="column" spacing={4}>
          <Text variant="body" color="text.quiet">
            <FormattedMessage
              id="MicrosoftWordIntegrationInfo.descriptionSuccess"
              defaultMessage="You'll see an <strong>Edit with Microsoft Desktop</strong> button when you open a ticket with a compatible document."
              description="Description for success message of Microsoft Word integration"
              values={{
                strong: (chunks) => <strong>{chunks}</strong>,
              }}
            />
          </Text>
          <Layout>
            <Button
              icon="check"
              iconPosition="left"
              text={intl.formatMessage({
                id: 'MicrosoftWordIntegrationInfo.connectedButton',
                defaultMessage: 'Connected',
                description: 'Connected button text',
              })}
              variant="primary"
              onClick={() => {}}
              disabled
            />
          </Layout>
        </Layout>
        <Layout spacing={4} py={4}>
          <Layout direction="column">
            <Text variant="body-bold">
              <FormattedMessage
                id="MicrosoftWordIntegrationInfo.sharePointSiteUrlLabel"
                defaultMessage="SharePoint Site URL"
                description="SharePoint Site URL label"
              />
            </Text>
            <Text variant="body" color="text.quiet">
              {sharePointSiteUrl}
            </Text>
          </Layout>
          <Layout direction="column">
            <Text variant="body-bold">
              <FormattedMessage
                id="MicrosoftWordIntegrationInfo.microsoftTenantIdLabel"
                defaultMessage="Microsoft Tenant ID"
                description="Microsoft Tenant ID label"
              />
            </Text>
            <Text variant="body" color="text.quiet">
              {tenantId}
            </Text>
          </Layout>
        </Layout>
      </Section>
      {status !== SharepointStatusType.Connected && (
        <Layout preset="buttons">
          <Button
            text={intl.formatMessage({
              id: 'MicrosoftWordIntegrationInfo.manageConfigurationButton',
              defaultMessage: 'Manage',
              description: 'Manage configuration button text',
            })}
            onClick={onManageConfiguration}
          />
        </Layout>
      )}
    </Layout>
  );
}

export default MicrosoftWordIntegrationInfo;
